import { QueryClient } from '@tanstack/react-query';
import { Api } from './Api';

export const queryClient = new QueryClient();

// A schema revision separates incompatible payloads. Freshness is bounded in
// memory; reloading the page clears this cache and never persists user data.
export function fetchTypeahead() {
  return queryClient.fetchQuery({
    queryKey: ['typeahead', 'v1'],
    queryFn: async () => (await Api.get('/search/init_typeahead')).data,
    staleTime: 5 * 60 * 1000,
    retry: false
  });
}

export function fetchSearch(query: string | null, token: string) {
  return queryClient.fetchQuery({
    queryKey: ['search', 'v3', query || ''],
    queryFn: async () =>
      (
        await Api.get('/search/move', {
          params: { q: query || '' },
          headers: { 'Recaptcha-Token': token }
        })
      ).data,
    staleTime: 60 * 1000,
    retry: false
  });
}
